import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function SpecialtyDetailsNav({department}) {
    const {locale} = useRouter();
    const departmentName =
        department?.department_name || getLocaleContent(locale, 'page.specialty-page.default-specialty');

    const breadcrumbItems = [
        {label: '', href: '/', icon: <HomeOutlined />},
        {
            label: getLocaleContent(locale, 'page.specialty-page.breadcrumb-title'),
            href: '/chuyen-khoa',
            color: '#006940',
        },
    ];

    if (department) {
        breadcrumbItems.push({label: departmentName, href: '#', uppercase: false});
    }

    return (
        <div>
            <BreadcrumbNav items={breadcrumbItems} />
        </div>
    );
}

export default SpecialtyDetailsNav;
